"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var NodeHandlerDefinitionAdapter_1 = require("./NodeHandlerDefinitionAdapter");
/**
 * Converts GraphQL definitions to joined operations for all its selections.
 */


var NodeHandlerDefinitionOperation =
/*#__PURE__*/
function (_NodeHandlerDefinitio) {
  _inherits(NodeHandlerDefinitionOperation, _NodeHandlerDefinitio);

  function NodeHandlerDefinitionOperation(util, settings) {
    _classCallCheck(this, NodeHandlerDefinitionOperation);

    return _possibleConstructorReturn(this, _getPrototypeOf(NodeHandlerDefinitionOperation).call(this, 'OperationDefinition', util, settings));
  }

  _createClass(NodeHandlerDefinitionOperation, [{
    key: "handle",
    value: function handle(operationDefinition, convertContext) {
      var _this = this;

      if (operationDefinition.operation !== 'query') {
        throw new Error('Unsupported definition operation: ' + operationDefinition.operation);
      } // We ignore the query name, as SPARQL doesn't support naming queries.
      // Variables


      if (operationDefinition.variableDefinitions) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = operationDefinition.variableDefinitions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var variableDefinition = _step.value;
            var name = variableDefinition.variable.name.value; // Put the default value in the context if it hasn't been defined yet.

            if (variableDefinition.defaultValue) {
              if (!convertContext.variablesDict[name]) {
                convertContext.variablesDict[name] = variableDefinition.defaultValue;
              }
            } // Handle type


            var typeNode = variableDefinition.type;
            var mandatory = typeNode.kind === 'NonNullType';

            if (mandatory) {
              typeNode = typeNode.type;
            }

            var list = typeNode.kind === 'ListType';

            if (list) {
              typeNode = typeNode.type;
            }

            var type = typeNode.name.value;
            convertContext.variablesMetaDict[name] = {
              mandatory: mandatory,
              list: list,
              type: type
            };
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      } // Directives


      var directiveOutputs = this.getDirectiveOutputs(operationDefinition.directives, operationDefinition.name ? operationDefinition.name.value : '', convertContext);

      if (!directiveOutputs) {
        return this.util.operationFactory.createBgp([]);
      } // Handle the operation


      var operation = this.util.joinOperations(operationDefinition.selectionSet.selections.map(function (selectionNode) {
        return _this.util.handleNode(selectionNode, convertContext);
      })); // Override operation if needed

      return this.handleDirectiveOutputs(directiveOutputs, operation);
    }
  }]);

  return NodeHandlerDefinitionOperation;
}(NodeHandlerDefinitionAdapter_1.NodeHandlerDefinitionAdapter);

exports.NodeHandlerDefinitionOperation = NodeHandlerDefinitionOperation;